module.exports = __webpack_public_path__ + "img/pic_feed_spoffer2.23c273ed.png";